import React, { useState, useEffect, useContext, useMemo } from "react";
import axios from "../../../axios/index";

// custome hooks
import usePriceSeprator from "../../../hooks/usePriceSeparator";

// Context
import { UserContext } from "../../Context/UserContextProvider";

// Styles
import styles from "../DashboardFileManagement/DashboardFileManagement.module.css";
// import Mainstyles from "./SavedFiles.module.css"

// Re Useable Components
import DashboardSideMenu from "../DashboardReuseAbleComponents/DashboardSideMenu";
import DashboardHeader from "../DashboardReuseAbleComponents/DashboardHeader";
import MyNotesCard from "./../Notes/MyNotes/MyNotesCard";
import ShowProfileModal from "../DashboardFileManagement/CardDetail/ShowProfileModal";
import Pagination from "@mui/material/Pagination";
import Stack from "@mui/material/Stack";
import SaleReminderCard from "./SaleReminderCard";
import RentReminderCard from "./RentReminderCard";
import MeetingsArchiveCard from "../Meeting/Archive/MeetingsArchiveCard";

//Images
import arrowIcon from "../../../assets/img/DashboardICons/ArrowRounded.svg";
import { useHistory } from "react-router-dom/cjs/react-router-dom.min";
import CustomPagination from "../../CustomPagination/CustomPagination";

export default function Reminders() {
  const { userToken, userData } = useContext(UserContext);
  const [page, setPage] = useState({
    pageNumber: 1,
    pageCount: 5,
  });
  const [query, setQuery] = useState("");
  const [modalShow, setModalShow] = useState(false);
  const [cardData, setCardData] = useState();
  const [carRentData, setCardRentData] = useState();
  const [notesData, setNotesData] = useState();
  const [meetingssData, setMeetingsData] = useState();
  const [isLoading, setIsLoading] = useState(true);
  const history = useHistory();

  const [filterCardsByCategory, setFilterCardsByCategory] = useState({
    files: true,
    notes: false,
    meetings: false,
  });

  useMemo(() => cardData, [cardData]);
  useMemo(() => notesData, [notesData]);

  useEffect(() => {
    const dataHandler = async () => {
      const getSalesData = await axios.get("Reminder/GetEstates?take=20&pageId=1", {
        headers: { authorization: "Bearer " + userToken },
      });

      const getNotes = await axios.get("Reminder/GetNotes?take=20&pageId=1", {
        headers: { authorization: "Bearer " + userToken },
      });

      const getMeetingReminders = await axios.get("Reminder/GetMeetings?take=20&pageId=1", {
        headers: { authorization: "Bearer " + userToken },
      });

      if (filterCardsByCategory.files) {
        setPage(prev => {
          return { ...prev, pageNumber: 1, pageCount: getSalesData.data.data.pageCount };
        });
      } else if (filterCardsByCategory.notes) {
        setPage(prev => {
          return { ...prev, pageNumber: 1, pageCount: getNotes.data.data.pageCount };
        });
      } else if (filterCardsByCategory.meetings) {
        setPage(prev => {
          return { ...prev, pageNumber: 1, pageCount: getMeetingReminders.data.data.pageCount };
        });
      }
      const salesData = await getSalesData.data.data.data;
      const meetingssData = await getMeetingReminders.data.data.data;
      const salesCard = await salesData?.filter(item => item.totalPrice !== 0);
      const rentsCard = await salesData?.filter(item => item.rentPrice !== 0);
      setCardData(salesCard);
      setCardRentData(rentsCard);
      setMeetingsData(meetingssData);
      setNotesData(getNotes.data.data.data);

      setIsLoading(false);
    };

    dataHandler();
  }, [userToken, filterCardsByCategory, userData]);

  const search = data => {
    return data.filter(item => item.title.toLowerCase().includes(query));
  };

  return (
    <>
      <ShowProfileModal show={modalShow} onHide={() => setModalShow(false)} />
      {isLoading ? (
        <div className={styles.loader_container}>
          <div className={styles.spinner}></div>
        </div>
      ) : (
        <div className="container-fluid">
          <div className="row">
            <div className="col-md-9">
              <div className={`mt-3 px-0 ${styles.file_cards_container}`}>
                <DashboardHeader onClick={() => setModalShow(true)} class="px-3" query={query} setQuery={setQuery} />
                <div className="py-2">
                  <div className="container-fluid">
                    <div className="d-flex justify-content-start flex-wrap align-items-center mt-3 me-2" dir="rtl">
                      <div className="w-100 d-flex align-items-center justify-content-start flex-wrap mt-2 mb-2">
                        <a href="#" onClick={history.goBack}>
                          <img className="ms-2" src={arrowIcon} alt="icon" />
                        </a>
                        <div className={styles.text1}>یادآور</div>
                      </div>

                      <div className="w-100 d-flex align-items-center justify-content-between flex-wrap mt-4 mb-2">
                        <div className={`d-flex align-items-center justify-content-between px-1 ${styles.filter_btns_right_container}`}>
                          <div
                            className={`mx-2 ${filterCardsByCategory.files ? styles.selected_card_category : styles.unselected_card_category}`}
                            onClick={cardHandler}
                            id="files">
                            فایل‌ها
                          </div>
                          <div
                            className={`mx-2 ${filterCardsByCategory.notes ? styles.selected_card_category : styles.unselected_card_category}`}
                            onClick={cardHandler}
                            id="notes">
                            یادداشت‌ها
                          </div>
                          <div
                            className={`mx-2 ${filterCardsByCategory.meetings ? styles.selected_card_category : styles.unselected_card_category}`}
                            onClick={cardHandler}
                            id="meetings">
                            جلسات
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {filterCardsByCategory.files === true ? (
                  <div
                    className={`w-100 d-flex justify-content-xl-between justify-content-center px-2 px-md-0 flex-wrap align-items-center mt-3 flex-wrap ${styles.cards_container}`}
                    dir="rtl">
                    {cardData == "" || carRentData == "" ? (
                      <div className={`w-100 d-flex align-items-center justify-content-center ${styles.notfound_text}`}>
                        هنوز هیچ موردی برای نمایش وجود ندارد
                      </div>
                    ) : (
                      <>
                        <SaleReminderCard cardData={search(cardData)} usePriceSeprator={usePriceSeprator} />
                        <RentReminderCard rentsCard={search(carRentData)} usePriceSeprator={usePriceSeprator} />
                      </>
                    )}
                  </div>
                ) : filterCardsByCategory.notes === true ? (
                  <MyNotesCard notesData={search(notesData)} reminder />
                ) : (
                  filterCardsByCategory.meetings === true && <MeetingsArchiveCard cardData={search(meetingssData)} />
                )}

                <Stack
                  className={styles.pagination}
                  spacing={1}
                  sx={{
                    direction: "ltr",
                    bottom: "0",
                    height: "85px",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center !important",
                  }}>
                  <CustomPagination count={page.pageCount} variant="outlined" shape="rounded" page={page.pageNumber} onChange={paginationHandler} />
                </Stack>
              </div>
            </div>
            <div className="col-md-3">
              {/* sideMenu starts */}
              <DashboardSideMenu reminder />
              {/* sideMenu ends */}
            </div>
          </div>
        </div>
      )}
    </>
  );

  function cardHandler(event) {
    if (event.target.id === "files") {
      setFilterCardsByCategory(prev => {
        return { ...prev, files: true, notes: false, meetings: false };
      });
    } else if (event.target.id === "notes") {
      setFilterCardsByCategory(prev => {
        return { ...prev, notes: true, files: false, meetings: false };
      });
    } else if (event.target.id === "meetings") {
      setFilterCardsByCategory(prev => {
        return { ...prev, meetings: true, files: false, notes: false };
      });
    }
  }

  async function paginationHandler(event, value) {
    setIsLoading(true);
    if (filterCardsByCategory.files) {
      const getSalesData = await axios.get(`Reminder/GetEstates?take=20&PageId=${value}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: value, pageCount: getSalesData.data.data.pageCount };
      });
      const salesData = await getSalesData.data.data.data;
      const salesCard = await salesData?.filter(item => item.totalPrice !== 0);
      const rentsCard = await salesData?.filter(item => item.rentPrice !== 0);
      setCardData(salesCard);
      setCardRentData(rentsCard);
      setIsLoading(false);
    } else if (filterCardsByCategory.notes) {
      const getNotes = await axios.get(`Reminder/GetNotes?take=20&PageId=${value}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: value, pageCount: getNotes.data.data.pageCount };
      });
      setNotesData(getNotes.data.data.data);
      setIsLoading(false);
    } else if (filterCardsByCategory.meetings) {
      const getMeetingReminders = await axios.get(`Reminder/GetMeetings?take=20&PageId=${value}`, {
        headers: { authorization: "Bearer " + userToken },
      });
      setPage(prev => {
        return { ...prev, pageNumber: value, pageCount: getMeetingReminders.data.data.pageCount };
      });
      const meetingssData = await getMeetingReminders.data.data.data;
      setMeetingsData(meetingssData);
      setIsLoading(false);
    }
  }
}
